import React from 'react';
import PropTypes from 'prop-types';
import { ReactSVG } from 'react-svg';
import { useTranslation } from 'react-i18next';
import { iconList as icons } from 'assets';
import Select from '../Select/Select';
import { Container, List, ListItem, PerPageWrapper, PerPageLabel, BottomText } from './CisPagination.styled';

function CisPagination({
  currentPage,
  totalPages,
  totalItems,
  perPage,
  perPageOptions,
  onPageChange,
  onPerPageChange,
  styled,
}) {
  const { t } = useTranslation();
  const prevDisabled = currentPage <= 1;
  const nextDisabled = currentPage >= totalPages;

  const prevPage = currentPage > 1 ? currentPage - 1 : null;
  const nextPage = currentPage < totalPages ? currentPage + 1 : null;
  const visiblePages = [prevPage, currentPage, nextPage].filter(Boolean);

  const showEntriesText = totalItems !== undefined && perPage !== undefined;
  const startItem = showEntriesText ? (currentPage - 1) * perPage + 1 : null;
  const endItem = showEntriesText ? Math.min(currentPage * perPage, totalItems) : null;

  return (
    <>
      <Container styled={styled}>
        <List>
          <ListItem disabled={prevDisabled}>
            <button type="button" onClick={() => !prevDisabled && onPageChange(prevPage || 0)}>
              <ReactSVG src={icons.arrowLeft} />
            </button>
          </ListItem>
          {visiblePages.map((page) => (
            <ListItem active={currentPage === page} key={page}>
              <button type="button" onClick={() => onPageChange(page)}>
                {page}
              </button>
            </ListItem>
          ))}
          <ListItem disabled={nextDisabled}>
            <button type="button" onClick={() => !nextDisabled && onPageChange(nextPage || totalPages)}>
              <ReactSVG src={icons.arrowRight} />
            </button>
          </ListItem>
        </List>
        <PerPageWrapper>
          <PerPageLabel>{t('global.perPage')}</PerPageLabel>
          <Select
            small
            onChange={onPerPageChange}
            value={perPageOptions.find((opt) => opt.value === perPage) || null}
            options={perPageOptions}
            name="perPage"
          />
        </PerPageWrapper>
      </Container>
      {showEntriesText && (
        <BottomText>
          {t('global.pagination.showing_entries', {
            start: startItem,
            end: endItem,
            total: totalItems,
          })}
        </BottomText>
      )}
    </>
  );
}

CisPagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  totalItems: PropTypes.number,
  perPage: PropTypes.number.isRequired,
  perPageOptions: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) })
  ),
  onPageChange: PropTypes.func.isRequired,
  onPerPageChange: PropTypes.func.isRequired,
  styled: PropTypes.object,
};

CisPagination.defaultProps = {
  totalItems: undefined,
  styled: undefined,
  perPageOptions: [
    { label: 1, value: 1 },
    { label: 10, value: 10 },
    { label: 20, value: 20 },
    { label: 50, value: 50 },
    { label: 100, value: 100 },
  ],
};

export default CisPagination; 